/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EquipmentTypeCatalogDtoCategory } from './EquipmentTypeCatalogDtoCategory';
import {
    EquipmentTypeCatalogDtoCategoryFromJSON,
    EquipmentTypeCatalogDtoCategoryFromJSONTyped,
    EquipmentTypeCatalogDtoCategoryToJSON,
} from './EquipmentTypeCatalogDtoCategory';
import type { EquipmentTypeCatalogDtoSingleDetectorConnectorType } from './EquipmentTypeCatalogDtoSingleDetectorConnectorType';
import {
    EquipmentTypeCatalogDtoSingleDetectorConnectorTypeFromJSON,
    EquipmentTypeCatalogDtoSingleDetectorConnectorTypeFromJSONTyped,
    EquipmentTypeCatalogDtoSingleDetectorConnectorTypeToJSON,
} from './EquipmentTypeCatalogDtoSingleDetectorConnectorType';
import type { EquipmentTypeCatalogDtoWithSerialNumber } from './EquipmentTypeCatalogDtoWithSerialNumber';
import {
    EquipmentTypeCatalogDtoWithSerialNumberFromJSON,
    EquipmentTypeCatalogDtoWithSerialNumberFromJSONTyped,
    EquipmentTypeCatalogDtoWithSerialNumberToJSON,
} from './EquipmentTypeCatalogDtoWithSerialNumber';
import type { EquipmentTypeCatalogDtoBrand1 } from './EquipmentTypeCatalogDtoBrand1';
import {
    EquipmentTypeCatalogDtoBrand1FromJSON,
    EquipmentTypeCatalogDtoBrand1FromJSONTyped,
    EquipmentTypeCatalogDtoBrand1ToJSON,
} from './EquipmentTypeCatalogDtoBrand1';
import type { EquipmentTypeCatalogDtoManufacturer } from './EquipmentTypeCatalogDtoManufacturer';
import {
    EquipmentTypeCatalogDtoManufacturerFromJSON,
    EquipmentTypeCatalogDtoManufacturerFromJSONTyped,
    EquipmentTypeCatalogDtoManufacturerToJSON,
} from './EquipmentTypeCatalogDtoManufacturer';
import type { EquipmentTypeCatalogDtoSubCategory } from './EquipmentTypeCatalogDtoSubCategory';
import {
    EquipmentTypeCatalogDtoSubCategoryFromJSON,
    EquipmentTypeCatalogDtoSubCategoryFromJSONTyped,
    EquipmentTypeCatalogDtoSubCategoryToJSON,
} from './EquipmentTypeCatalogDtoSubCategory';
import type { EquipmentTypeCatalogDtoDeviceInterfaceType } from './EquipmentTypeCatalogDtoDeviceInterfaceType';
import {
    EquipmentTypeCatalogDtoDeviceInterfaceTypeFromJSON,
    EquipmentTypeCatalogDtoDeviceInterfaceTypeFromJSONTyped,
    EquipmentTypeCatalogDtoDeviceInterfaceTypeToJSON,
} from './EquipmentTypeCatalogDtoDeviceInterfaceType';

/**
 * 
 * @export
 * @interface EquipmentTypeCatalogDto
 */
export interface EquipmentTypeCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    id: string;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoWithSerialNumber}
     * @memberof EquipmentTypeCatalogDto
     */
    withSerialNumber?: EquipmentTypeCatalogDtoWithSerialNumber | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoCategory}
     * @memberof EquipmentTypeCatalogDto
     */
    category?: EquipmentTypeCatalogDtoCategory | null;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoSubCategory}
     * @memberof EquipmentTypeCatalogDto
     */
    subCategory?: EquipmentTypeCatalogDtoSubCategory | null;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoManufacturer}
     * @memberof EquipmentTypeCatalogDto
     */
    manufacturer?: EquipmentTypeCatalogDtoManufacturer | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoBrand1}
     * @memberof EquipmentTypeCatalogDto
     */
    brand1?: EquipmentTypeCatalogDtoBrand1 | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    brand2?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EquipmentTypeCatalogDto
     */
    mostCommon?: number | null;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoDeviceInterfaceType}
     * @memberof EquipmentTypeCatalogDto
     */
    deviceInterfaceType?: EquipmentTypeCatalogDtoDeviceInterfaceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof EquipmentTypeCatalogDto
     */
    additionalPropertiesAvailable?: boolean | null;
    /**
     * 
     * @type {EquipmentTypeCatalogDtoSingleDetectorConnectorType}
     * @memberof EquipmentTypeCatalogDto
     */
    singleDetectorConnectorType?: EquipmentTypeCatalogDtoSingleDetectorConnectorType | null;
    /**
     * 
     * @type {boolean}
     * @memberof EquipmentTypeCatalogDto
     */
    radiationTherapy?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    diagnostics?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    radiationSafety?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    otherApplication?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    fallbackPicture?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EquipmentTypeCatalogDto
     */
    isVisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EquipmentTypeCatalogDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeCatalogDto
     */
    $type?: EquipmentTypeCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const EquipmentTypeCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoEquipmentTypeCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.EquipmentTypeCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EquipmentTypeCatalogDtoTypeEnum = typeof EquipmentTypeCatalogDtoTypeEnum[keyof typeof EquipmentTypeCatalogDtoTypeEnum];



/**
 * Check if a given object implements the EquipmentTypeCatalogDto interface.
 */
export function instanceOfEquipmentTypeCatalogDto(value?: unknown): value is EquipmentTypeCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EquipmentTypeCatalogDtoTypeEnum)[0];
}

export function EquipmentTypeCatalogDtoFromJSON(json: any): EquipmentTypeCatalogDto {
    return EquipmentTypeCatalogDtoFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'withSerialNumber': json['withSerialNumber'] == null ? undefined : EquipmentTypeCatalogDtoWithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': json['typeNumber'] == null ? undefined : json['typeNumber'],
        'category': json['category'] == null ? undefined : EquipmentTypeCatalogDtoCategoryFromJSON(json['category']),
        'subCategory': json['subCategory'] == null ? undefined : EquipmentTypeCatalogDtoSubCategoryFromJSON(json['subCategory']),
        'manufacturer': json['manufacturer'] == null ? undefined : EquipmentTypeCatalogDtoManufacturerFromJSON(json['manufacturer']),
        'model': json['model'] == null ? undefined : json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'brand1': json['brand1'] == null ? undefined : EquipmentTypeCatalogDtoBrand1FromJSON(json['brand1']),
        'brand2': json['brand2'] == null ? undefined : json['brand2'],
        'mostCommon': json['mostCommon'] == null ? undefined : json['mostCommon'],
        'deviceInterfaceType': json['deviceInterfaceType'] == null ? undefined : EquipmentTypeCatalogDtoDeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'additionalPropertiesAvailable': json['additionalPropertiesAvailable'] == null ? undefined : json['additionalPropertiesAvailable'],
        'singleDetectorConnectorType': json['singleDetectorConnectorType'] == null ? undefined : EquipmentTypeCatalogDtoSingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'radiationTherapy': json['radiationTherapy'] == null ? undefined : json['radiationTherapy'],
        'diagnostics': json['diagnostics'] == null ? undefined : json['diagnostics'],
        'radiationSafety': json['radiationSafety'] == null ? undefined : json['radiationSafety'],
        'otherApplication': json['otherApplication'] == null ? undefined : json['otherApplication'],
        'description': json['description'] == null ? undefined : json['description'],
        'fallbackPicture': json['fallbackPicture'] == null ? undefined : json['fallbackPicture'],
        'isVisible': json['isVisible'] == null ? undefined : json['isVisible'],
        'isRegistrable': json['isRegistrable'] == null ? undefined : json['isRegistrable'],
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EquipmentTypeCatalogDtoToJSON(value?: EquipmentTypeCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'withSerialNumber': EquipmentTypeCatalogDtoWithSerialNumberToJSON(value['withSerialNumber']),
        'typeNumber': value['typeNumber'],
        'category': EquipmentTypeCatalogDtoCategoryToJSON(value['category']),
        'subCategory': EquipmentTypeCatalogDtoSubCategoryToJSON(value['subCategory']),
        'manufacturer': EquipmentTypeCatalogDtoManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'brand1': EquipmentTypeCatalogDtoBrand1ToJSON(value['brand1']),
        'brand2': value['brand2'],
        'mostCommon': value['mostCommon'],
        'deviceInterfaceType': EquipmentTypeCatalogDtoDeviceInterfaceTypeToJSON(value['deviceInterfaceType']),
        'additionalPropertiesAvailable': value['additionalPropertiesAvailable'],
        'singleDetectorConnectorType': EquipmentTypeCatalogDtoSingleDetectorConnectorTypeToJSON(value['singleDetectorConnectorType']),
        'radiationTherapy': value['radiationTherapy'],
        'diagnostics': value['diagnostics'],
        'radiationSafety': value['radiationSafety'],
        'otherApplication': value['otherApplication'],
        'description': value['description'],
        'fallbackPicture': value['fallbackPicture'],
        'isVisible': value['isVisible'],
        'isRegistrable': value['isRegistrable'],
        'defaultImageId': value['defaultImageId'],
        '$type': value['$type'],
    });
}

